import { DOCUMENT, isPlatformBrowser, NgClass, ViewportScroller } from '@angular/common';
import { Component, EventEmitter, HostListener, Inject, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { RouterLink } from '@angular/router';
import { StoreSpecificConfigService } from '@scalefast/config-angular';
import { StaticFileHash } from '@scalefast/ecommerce-core';
import { EventTypeEnumerate } from '../../../core/enumerates';
import { GenericEventService } from '../../services/';
import { AppCountrySelectComponent } from './country-select/country-select.component';
import { AppLoginButtonComponent } from './login/login-button.component';
import { AppMinicartOffCanvasComponent } from './minicart/minicart-offcanvas/minicart-offcanvas.component';
import { AppSearchModalComponent } from './search/search-modal/search-modal.component';
import { AppStoreNavComponent } from './store-nav/store-nav.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    NgClass,
    AppCountrySelectComponent,
    AppLoginButtonComponent,
    RouterLink,
    AppStoreNavComponent,
    AppSearchModalComponent,
    AppMinicartOffCanvasComponent,
    StaticFileHash,
  ],
  // changeDetection: ChangeDetectionStrategy.OnPush, FIXME: enable when minicart and search componetns can be verified to be
  // compatible with OnPush
})
export class AppHeaderComponent implements OnInit {
  isSticky: boolean = false;
  headerTop: string | undefined;
  serviceUrl: string = '';
  isMobileOpen: boolean = false;
  headerSiteHeight: number | undefined;
  @Output()
  public domChange = new EventEmitter();
  @Output() mobileOpenEvent = new EventEmitter();

  constructor(
    private genericEventService: GenericEventService,
    @Inject(DOCUMENT) private _doc: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
    private storeSpecificConfigService: StoreSpecificConfigService,
    private viewportScroller: ViewportScroller,
  ) {
    this.serviceUrl = this.storeSpecificConfigService.get()?.helpUrl?.service;
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const headerSite = this._doc.getElementById('site_header');
    let headerSiteHeight = headerSite?.offsetHeight;

    if (headerSiteHeight === undefined) {
      return;
    }

    if (headerSite) {
      const headerPosition = headerSite.getBoundingClientRect().y;
      if (headerPosition <= 0) {
        this.isSticky = true;
        headerSite.style.paddingTop = headerSiteHeight.toString() + 'px';
      } else {
        this.isSticky = false;
        headerSite.style.paddingTop = '0';
      }
    }
  }

  ngOnInit(): void {
    this.#setHeaderOffset();
    this.genericEventService.subscribe(EventTypeEnumerate.APP_MENU_CLICK, (event: any) => {
      this.isMobileOpen = event.status;
    });
  }

  listenBackdropClick(data: boolean) {
    this.isMobileOpen = data;
    this.mobileOpenEvent.emit(this.isMobileOpen);
  }

  clickMenu(): void {
    this.isMobileOpen = !this.isMobileOpen;
    this.mobileOpenEvent.emit(this.isMobileOpen);
  }

  /**
   * Sets an offset for ViewportScroller so it takes into account the sticky header size when scrolling to anchor links
   * The offset takes in account only the small fixed header (header__site)
   * It doesn't include the advantange-banner or the header__top-bg
   */
  #setHeaderOffset() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const headerSite = this._doc.getElementById('header__site');
    const headerSiteHeight = headerSite?.offsetHeight;
    if (headerSiteHeight === undefined) {
      return;
    }
    // To improve: the offset is global, it's fine to do it in header as nothing else is changing it for now
    // If something else needs to modify offsets we'll need to create a service to orchestrate the global offset
    this.viewportScroller.setOffset([0, headerSiteHeight]);
  }
}
